import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../components/Loading";
import Menu from "../../components/Menu";

import api from "../../services/api";

const initialState = {
    id: "",
    descricao: "",
    passadas: "",
    dias: "",
    baixa_produto: "0"
}

const associateInitialState = {
    id: null,
    descricao: "",
    passadas: "",
    dias: ""
}

const OPTIONS_BOOLEAN = [
    { label: "Não", value: "0" },
    { label: "Sim", value: "1" }
]

export default function ManutencaoTipos() {
    const [form, setForm] = useState({ ...initialState });
    const [formAssociate, setFormAssociate] = useState(associateInitialState);
    const [produtos, setProdutos] = useState([]);
    const [tipos, setTipos] = useState([]);

    const [expandedRows, setExpandedRows] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isAssociateVisible, setIsAssociateVisible] = useState(false);

    const toast = useRef(null);

    const showError = (error) => toast.current.show({ summary: "Ocorreu um Erro", severity: "error", detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: "Sucesso", severity: "success", detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("manutencao/tipos").then((response) => {
            setTipos(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            toast.current.show({
                summary: "Erro no Servidor",
                severity: "error",
                detail: "Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI."
            });
        });
    }, []);

    const handleEdit = rowData => {
        setIsEditing(true);
        setForm({ ...rowData });
        setIsVisible(true);
    }

    const handleSubmit = _ => {
        if (form.descricao === "")
            return;

        if (isEditing) {
            setIsLoading(true);
            api.put(`manutencao/tipos/${form.id}/update`, form).then((response) => {
                fetchData();
                hideDialog();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);

            });
        } else {
            setIsLoading(true);
            api.post("manutencao/tipos", form).then((response) => {
                fetchData();
                hideDialog();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);

            });
        }

    }

    const handleSubmitAssociate = _ => {
        if (formAssociate.id !== null && formAssociate.produto_id !== null) {
            setIsLoading(true);
            api.post("manutencao/tipos/" + formAssociate.id + "/associar", formAssociate).then((response) => {
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const handleDelete = rowData => {
        confirmDialog({
            header: "Confirmação",
            acceptLabel: "Excluir",
            acceptClassName: "p-button-danger",
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                setIsLoading(true);
                api.delete(`manutencao/tipos/${rowData.id}/delete`).then((response) => {
                    fetchData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const onShowAssociate = rowData => {
        setIsAssociateVisible(true);
        setFormAssociate({ ...rowData });
    }

    const onHideAssociate = _ => setIsAssociateVisible(false);

    const renderFooterAssociate = _ => {
        return (
            <div>
                <Button className="p-button-secondary" label="Cancelar" onClick={onHideAssociate} />
                <Button className="p-button-success" label="Salvar" onClick={handleSubmitAssociate} />
            </div>
        )
    }

    const rowExpandedTemplate = (data) => {
        return (
            <div>
                <DataTable
                    emptyMessage="Nenhum produto associado."
                    responsiveLayout="scroll"
                    value={data.produtos}
                    size="small"
                >
                </DataTable>
            </div>
        )
    }

    const hideDialog = () => {
        setIsVisible(false);
        if (isEditing) {
            setIsEditing(false);
            setForm({ ...initialState });
        }
    }

    useEffect(() => {
        api.get("produtos").then((response) => {
            setProdutos(response.data);
        }).catch((error) => setProdutos([]));
        fetchData();
    }, [fetchData]);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog onHide={hideDialog} breakpoints={{ "960px": "90vw" }} style={{ minWidth: "30vw" }} visible={isVisible} header={isEditing ? "Editar" : "Cadastrar"} footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog} />
                    <Button className="p-button-success" label="Salvar" loading={isLoading} onClick={handleSubmit} />
                </div>
            )}>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="descricao">Descrição: </label>
                        <InputText
                            onChange={e => setForm({ ...form, descricao: e.target.value })}
                            placeholder="Descreva o tipo de manutenção..."
                            value={form.descricao}
                        />
                    </div>

                    <div className="p-field">
                        <label htmlFor="baixa_produto">Baixa Produto? </label>
                        <Dropdown
                            onChange={e => setForm({ ...form, baixa_produto: e.value })}
                            options={OPTIONS_BOOLEAN}
                            placeholder="Exemplo: baixa de produto?"
                            value={form.baixa_produto}
                        />
                    </div>

                    <div className="p-field">
                        <label htmlFor="passadas">Nº Passadas: </label>
                        <InputText
                            onChange={e => setForm({ ...form, passadas: e.target.value })}
                            placeholder="Exemplo: 240000000"
                            type="number"
                            value={form.passadas}
                        />
                    </div>

                    <div className="p-field">
                        <label htmlFor="dias">Periodicidade em Dias: </label>
                        <InputText
                            onChange={e => setForm({ ...form, dias: e.target.value })}
                            placeholder="Exemplo: 365 (um ano)"
                            type="number"
                            value={form.dias}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                footer={renderFooterAssociate}
                header="Assossiação de Produtos"
                onHide={onHideAssociate}
                position="top"
                style={{ minWidth: "30vw" }}
                visible={isAssociateVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="manutencao_tipo_id">Manutenção: </label>
                        <InputText
                            readOnly
                            value={formAssociate.descricao}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="produto_id">Produto: </label>
                        <Dropdown
                            emptyFilterMessage="Nenhum produto encontrado."
                            filter
                            onChange={e => setFormAssociate({ ...formAssociate, produto_id: e.value })}
                            options={produtos}
                            optionLabel="descricao"
                            optionValue="id"
                            placeholder="Selecione um produto..."
                            value={formAssociate.produto_id}
                        />
                    </div>

                    <div className="p-field">
                        <label htmlFor="passadas">Nº Passadas: </label>
                        <InputText
                            onChange={e => setForm({ ...form, passadas: e.target.value })}
                            placeholder="Exemplo: 240000000"
                            type="number"
                            value={form.passadas}
                        />
                    </div>

                    <div className="p-field">
                        <label htmlFor="dias">Periodicidade em Dias: </label>
                        <InputText
                            onChange={e => setForm({ ...form, dias: e.target.value })}
                            placeholder="Exemplo: 365 (um ano)"
                            type="number"
                            value={form.dias}
                        />
                    </div>
                </div>
            </Dialog>

            {isLoading ? (
                <Loading />
            ) : (
                <Card
                    className="p-m-1"
                    title="Tipos de Manutenção"
                >
                    <div className="p-d-flex p-flex-row p-jc-end">
                        <Button className="p-button-primary p-mr-3 p-mt-3" icon="pi pi-plus" onClick={() => setIsVisible(true)} />
                    </div>

                    <DataTable
                        className="p-m-1"
                        emptyMessage="Nenhum tipo cadastrado até o momento."
                        expandedRows={expandedRows}
                        rowExpansionTemplate={rowExpandedTemplate}
                        onRowToggle={e => setExpandedRows(e.data)}
                        onRowExpand={(data) => {
                            console.log("ti => to implement")
                        }}
                        responsiveLayout="scroll"
                        paginator
                        rows={10}
                        size="small"
                        value={tipos}
                    >
                        <Column expander style={{ width: "3rem" }} />
                        <Column header="ID" field="id" sortable />
                        <Column header="Descrição" field="descricao" sortable />
                        <Column header="Nº Passadas" field="passadas" sortable />
                        <Column header="Nº Dias" field="dias" sortable />
                        <Column header="Baixa Produto" body={(rowData) => (
                            <span>{rowData.baixa_produto === "1" ? "Sim" : "Não"}</span>
                        )} />
                        <Column header="Ações" body={(rowData) => (
                            <div>
                                {rowData.baixa_produto === "1" ? (
                                    <Button className="p-button-warning p-mr-2" icon="pi pi-arrows-h" onClick={() => onShowAssociate(rowData)} title="Clique para fazer uma ASSOCIAÇÃO de PRODUTOS" />
                                ) : (
                                    <Button disabled className="p-button-warning p-mr-2" icon="pi pi-arrows-h"  />
                                )}
                                <Button className="p-button-primary p-mr-2" icon="pi pi-pencil" onClick={() => handleEdit(rowData)} title="Clique para EDITAR o registro" />
                                <Button className="p-button-danger p-mr-2" icon="pi pi-trash" onClick={() => handleDelete(rowData)} title="Clique para EXCLUIR o registro" />
                            </div>
                        )} />
                    </DataTable>
                </Card>
            )}

        </div>
    )
}